import React, { useEffect, useRef, useState } from "react";
import { sendCachedRequest } from '../utils/apiCache';
import { BASE_URL } from '../URL/constants';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const [aboutContent, setAboutContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const contentRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await sendCachedRequest(
          'POST',
          `${BASE_URL}/v1/public_site/public_site_info/get_list`,
          null,
          { cacheKey: 'public_site_info' }
        );
        
        const siteInfo = response.data.data.public_site_info;

        // Check if body_content exists and has content, otherwise fall back to about_us text
        const content = siteInfo?.about_content?.body || 
                        siteInfo?.about_us || 
                        'About content coming soon';
        
        setAboutContent(content);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  const sanitizedContent = DOMPurify.sanitize(aboutContent, {
    ADD_TAGS: ['style'],
    ADD_ATTR: ['style'],
  });

  useEffect(() => {
    const container = contentRef.current;
    if (!container) return;

    const handleClick = (event) => {
      const bookButton = event.target.closest('.book-btn');
      if (bookButton) {
        event.preventDefault();
        navigate('/', { state: { openBooking: true } });
      }
    };

    container.addEventListener('click', handleClick);
    return () => {
      container.removeEventListener('click', handleClick);
    };
  }, [navigate, aboutContent]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="about-page container py-5">
      <div 
        ref={contentRef}
        dangerouslySetInnerHTML={{
          __html: sanitizedContent
        }}
      />
    </div>
  );
};

export default About;